import React from "react";
import logo from "../../images/profile.jpg";
import LinkButton from "../Atoms/LinkButton";
import Image from "../Atoms/Image";
import { useTranslation } from "react-i18next";

interface IndexProps {}

const Index: React.FC<IndexProps> = () => {

  const { t } = useTranslation();

  return (
    <>
      <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center relative z-10">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
            {t("index.greeting")}
          </h1>
          <h2 className="text-4xl leading-normal mb-2 text-black-800 font-medium text-white">
            {t("index.role")}
          </h2>
          <p className="mb-8 leading-relaxed text-white">
            {t("home.description")}
          </p>
          <div className="flex justify-center">
            <LinkButton
              href="/contact"
              target="_self"
              className="inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg"
            >
              {t("home.button-contact")}
            </LinkButton>
            <LinkButton
              href="/projects"
              target="_self"
              className="ml-4 inline-flex text-white bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg"
            >
              {t("home.button-projects")}
            </LinkButton>
          </div>
        </div>
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
          <Image
            className="object-cover object-center rounded"
            source={logo}
            alt="logo"
          />
        </div>
      </div>
    </>
  );
};

export default Index;
